// assets/ml-freebies-download.js

(() => {
  console.log('✅ ml-freebies-download.js loaded');

  const SHEETS_ENDPOINT =
    "https://script.google.com/macros/s/AKfycbzPKK80cceg2OvdyWwT9jDeNlLgqFx2xZCVfYM8iEp_KtQHFtM3jmY3ruV6qMfuyKfr9A/exec";

  const MODAL_SELECTOR    = '[data-freebie-modal]';
  const FORM_SELECTOR     = '[data-freebie-form]';
  const CLOSE_SELECTOR    = '[data-freebie-close]';
  const TRIGGER_SELECTOR  = '[data-freebie-trigger], [data-freebie-button]';

  const GLOBAL_ERROR_SEL  = '[data-freebie-error]';

  const NAME_INPUT_SEL     = '[data-freebie-name]';
  const EMAIL_INPUT_SEL    = '[data-freebie-email]';
  const PID_INPUT_SEL      = '[data-freebie-input-product-id]';
  const PTITLE_INPUT_SEL   = '[data-freebie-input-product-title]';
  const DOWNLOAD_INPUT_SEL = '[data-freebie-input-download]';

  const NAME_ERROR_SEL   = '[data-freebie-error-name]';
  const EMAIL_ERROR_SEL  = '[data-freebie-error-email]';

  const CONSENT_INPUT_SEL = 'input[name="freebie_consent"]';
  const SUBMIT_BTN_SEL    = '[data-freebie-submit]';

  // ---------------- helpers ----------------

  function getModal() {
    return document.querySelector(MODAL_SELECTOR);
  }

  function getForm() {
    const modal = getModal();
    if (!modal) return null;
    return modal.querySelector(FORM_SELECTOR);
  }

  function clearGlobalError(form) {
    const globalError = form.querySelector(GLOBAL_ERROR_SEL);
    if (!globalError) return;
    globalError.textContent = '';
    globalError.hidden = true;
  }

  function showGlobalError(form, message) {
    const globalError = form.querySelector(GLOBAL_ERROR_SEL);
    if (!globalError) return;
    globalError.textContent = message;
    globalError.hidden = false;
  }

  function setFieldState(input, { error = false, success = false, messageEl = null, message = '' } = {}) {
    if (!input) return;
    const field = input.closest('.ml-freebie-modal__field');
    if (!field) return;

    field.classList.toggle('ml-freebie-modal__field--error', !!error);
    field.classList.toggle('ml-freebie-modal__field--success', !!success);

    if (messageEl) {
      messageEl.textContent = message || '';
    }
  }

  function updateSubmitState(form, modal) {
    if (!form || !modal) return;
    const submitBtn = form.querySelector(SUBMIT_BTN_SEL);
    if (!submitBtn) return;

    const nameInput  = form.querySelector(NAME_INPUT_SEL);
    const emailInput = form.querySelector(EMAIL_INPUT_SEL);
    const consent    = form.querySelector(CONSENT_INPUT_SEL);

    const hasName     = !!(nameInput && nameInput.value.trim());
    const hasEmail    = !!(emailInput && emailInput.value.trim());
    const hasConsent  = !!(consent && consent.checked);
    const hasDownload = !!(modal.dataset.downloadUrl || '');

    const ready = hasName && hasEmail && hasConsent && hasDownload;

    submitBtn.disabled = !ready;
    submitBtn.classList.toggle('is-disabled', !ready);
  }

  // ---------------- modal open/close ----------------

  function openModalFromTrigger(trigger) {
    const modal = getModal();
    if (!modal) {
      console.error('❌ Freebies modal not found in DOM');
      return;
    }

    const downloadUrl  = trigger.getAttribute('data-freebie-download') || '';
    const productId    = trigger.getAttribute('data-freebie-product-id') || '';
    const productTitle = trigger.getAttribute('data-freebie-product-title') || '';

    console.log('👉 openModal', { downloadUrl, productId, productTitle });

    modal.dataset.downloadUrl = downloadUrl;
    modal.dataset.productId = productId;
    modal.dataset.productTitle = productTitle;

    const pidInput    = modal.querySelector(PID_INPUT_SEL);
    const ptitleInput = modal.querySelector(PTITLE_INPUT_SEL);
    const dlInput     = modal.querySelector(DOWNLOAD_INPUT_SEL);

    if (pidInput)    pidInput.value    = productId;
    if (ptitleInput) ptitleInput.value = productTitle;
    if (dlInput)     dlInput.value     = downloadUrl;

    modal.classList.add('is-open');
    document.documentElement.classList.add('ml-modal-open');
    modal.setAttribute('aria-hidden', 'false');

    const form = getForm();
    if (form) {
      form.reset();

      // убираем все стейты при открытии
      const nameInput    = form.querySelector(NAME_INPUT_SEL);
      const emailInput   = form.querySelector(EMAIL_INPUT_SEL);
      const nameErrorEl  = form.querySelector(NAME_ERROR_SEL);
      const emailErrorEl = form.querySelector(EMAIL_ERROR_SEL);
      const consentBlock = form.querySelector('.ml-freebie-modal__consent');

      setFieldState(nameInput,  { error: false, success: false, messageEl: nameErrorEl,  message: '' });
      setFieldState(emailInput, { error: false, success: false, messageEl: emailErrorEl, message: '' });
      clearGlobalError(form);
      if (consentBlock) {
        consentBlock.classList.remove(
          'ml-freebie-modal__consent--error',
          'ml-freebie-modal__consent--success'
        );
      }

      updateSubmitState(form, modal);
    }

    const nameInput = modal.querySelector(NAME_INPUT_SEL);
    if (nameInput) {
      setTimeout(() => nameInput.focus(), 10);
    }
  }

  function closeModal() {
    const modal = getModal();
    if (!modal) return;

    modal.classList.remove('is-open');
    document.documentElement.classList.remove('ml-modal-open');
    modal.setAttribute('aria-hidden', 'true');
  }

  // ---------------- validation ----------------

  function validateForm(form, modal) {
    let isValid = true;

    const nameInput    = form.querySelector(NAME_INPUT_SEL);
    const emailInput   = form.querySelector(EMAIL_INPUT_SEL);
    const consentInput = form.querySelector(CONSENT_INPUT_SEL);

    const nameErrorEl  = form.querySelector(NAME_ERROR_SEL);
    const emailErrorEl = form.querySelector(EMAIL_ERROR_SEL);
    const globalError  = form.querySelector(GLOBAL_ERROR_SEL);
    const consentBlock = form.querySelector('.ml-freebie-modal__consent');

    // сбрасываем состояния
    setFieldState(nameInput,  { error: false, success: false, messageEl: nameErrorEl,  message: '' });
    setFieldState(emailInput, { error: false, success: false, messageEl: emailErrorEl, message: '' });

    if (globalError) {
      globalError.textContent = '';
      globalError.hidden = true;
    }
    if (consentBlock) {
      consentBlock.classList.remove('ml-freebie-modal__consent--error');
    }

    // NAME
    if (nameInput) {
      const value = nameInput.value.trim();
      if (!value) {
        isValid = false;
        setFieldState(nameInput, {
          error: true,
          success: false,
          messageEl: nameErrorEl,
          message: 'Please enter your name'
        });
      } else {
        setFieldState(nameInput, {
          error: false,
          success: true,
          messageEl: nameErrorEl,
          message: ''
        });
      }
    }

    // EMAIL
    if (emailInput) {
      const value = emailInput.value.trim();
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (!value || !emailPattern.test(value)) {
        isValid = false;
        setFieldState(emailInput, {
          error: true,
          success: false,
          messageEl: emailErrorEl,
          message: 'Please enter your email'
        });
      } else {
        setFieldState(emailInput, {
          error: false,
          success: true,
          messageEl: emailErrorEl,
          message: ''
        });
      }
    }

    // CONSENT
    if (consentInput) {
      const consentBlock = form.querySelector('.ml-freebie-modal__consent');
      if (!consentInput.checked) {
        isValid = false;
        if (consentBlock) {
          consentBlock.classList.remove('ml-freebie-modal__consent--success');
          consentBlock.classList.add('ml-freebie-modal__consent--error');
        }
        if (globalError) {
          globalError.textContent = 'Please confirm marketing consent to continue.';
          globalError.hidden = false;
        }
      } else if (consentBlock) {
        // успех по чекбоксу
        consentBlock.classList.remove('ml-freebie-modal__consent--error');
        consentBlock.classList.add('ml-freebie-modal__consent--success');
      }
    }

    // DOWNLOAD URL
    const downloadUrl = modal.dataset.downloadUrl || '';
    if (!downloadUrl) {
      isValid = false;
      if (globalError) {
        globalError.textContent = 'Download link is missing. Please contact support.';
        globalError.hidden = false;
      }
    }

    if (!isValid && globalError && !globalError.textContent) {
      globalError.textContent = 'Please fill in all required fields.';
      globalError.hidden = false;
    }

    // если форма валидна — убираем глобальную ошибку на всякий случай
    if (isValid) {
      clearGlobalError(form);
    }

    return isValid;
  }

  // live-валидация одного поля при вводе
  function validateSingleField(target, form) {
    const nameInput    = form.querySelector(NAME_INPUT_SEL);
    const emailInput   = form.querySelector(EMAIL_INPUT_SEL);
    const consentInput = form.querySelector(CONSENT_INPUT_SEL);

    const nameErrorEl  = form.querySelector(NAME_ERROR_SEL);
    const emailErrorEl = form.querySelector(EMAIL_ERROR_SEL);
    const consentBlock = form.querySelector('.ml-freebie-modal__consent');

    // имя
    if (target === nameInput) {
      const value = nameInput.value.trim();
      if (!value) {
        // просто убираем success, но не показываем новый текст ошибки до сабмита
        setFieldState(nameInput, {
          error: false,
          success: false,
          messageEl: nameErrorEl,
          message: ''
        });
      } else {
        setFieldState(nameInput, {
          error: false,
          success: true,
          messageEl: nameErrorEl,
          message: ''
        });
      }
    }

    // email
    if (target === emailInput) {
      const value = emailInput.value.trim();
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!value || !emailPattern.test(value)) {
        setFieldState(emailInput, {
          error: false,
          success: false,
          messageEl: emailErrorEl,
          message: ''
        });
      } else {
        setFieldState(emailInput, {
          error: false,
          success: true,
          messageEl: emailErrorEl,
          message: ''
        });
      }
    }

    // consent
    if (consentInput && target === consentInput && consentBlock) {
      if (consentInput.checked) {
        consentBlock.classList.remove('ml-freebie-modal__consent--error');
        consentBlock.classList.add('ml-freebie-modal__consent--success');
      } else {
        consentBlock.classList.remove('ml-freebie-modal__consent--success');
      }
    }

    // если пользователь что-то исправляет — пробуем убрать глобальную ошибку
    clearGlobalError(form);
  }

  // ---------------- download / sheets ----------------

  function startDownloadFromModal(modal) {
    const downloadUrl = modal.dataset.downloadUrl || '';
    if (!downloadUrl) {
      console.warn('⚠️ No downloadUrl in modal.dataset');
      return;
    }

    console.log('⬇️ Start download', downloadUrl);

    const link = document.createElement('a');
    link.href = downloadUrl;
    link.setAttribute('download', '');
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  async function sendToGoogleSheets(payload) {
    if (!SHEETS_ENDPOINT) {
      console.warn('⚠️ SHEETS_ENDPOINT is not set');
      return;
    }

    try {
      await fetch(SHEETS_ENDPOINT, {
        method: 'POST',
        mode: 'no-cors',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });
      console.log('✅ Sent to Google Sheets', payload);
    } catch (err) {
      console.error('❌ Error sending to Google Sheets', err);
    }
  }

  // ---------------- DOM events ----------------

  function onDocumentClick(event) {
    const trigger = event.target.closest(TRIGGER_SELECTOR);
    if (trigger) {
      event.preventDefault();
      console.log('✨ Freebie trigger clicked', trigger);
      openModalFromTrigger(trigger);
      return;
    }

    if (event.target.closest(CLOSE_SELECTOR)) {
      event.preventDefault();
      closeModal();
      return;
    }

    const modal = getModal();
    if (modal && modal.classList.contains('is-open')) {
      if (event.target === modal) {
        closeModal();
      }
    }
  }

  function onDocumentInput(event) {
    const form = event.target.closest(FORM_SELECTOR);
    if (!form) return;

    const modal = getModal();
    if (!modal) return;

    // live-валидация конкретного поля
    validateSingleField(event.target, form);

    // доступность кнопки
    updateSubmitState(form, modal);
  }

  async function onDocumentSubmit(event) {
    const form = event.target.closest(FORM_SELECTOR);
    if (!form) return;

    const modal = getModal();
    if (!modal) return;

    event.preventDefault();
    console.log('📝 Freebie form submit');

    const isValid = validateForm(form, modal);
    updateSubmitState(form, modal);

    if (!isValid) {
      console.warn('⚠️ Freebie form invalid');
      return; // поля уже покрасились
    }

    const nameInput  = form.querySelector(NAME_INPUT_SEL);
    const emailInput = form.querySelector(EMAIL_INPUT_SEL);

    const nicheValues = Array.from(
      form.querySelectorAll('input[name="freebie_niche[]"]:checked')
    ).map((el) => el.value);

    const softwareValues = Array.from(
      form.querySelectorAll('input[name="freebie_software[]"]:checked')
    ).map((el) => el.value);

    const consentInput = form.querySelector(CONSENT_INPUT_SEL);

    const payload = {
      name: nameInput ? nameInput.value.trim() : '',
      email: emailInput ? emailInput.value.trim() : '',
      niche: nicheValues.join(', '),
      software: softwareValues.join(', '),
      consent: consentInput && consentInput.checked ? 'yes' : 'no',
      productId: modal.dataset.productId || '',
      productTitle: modal.dataset.productTitle || '',
      downloadUrl: modal.dataset.downloadUrl || ''
    };

    await sendToGoogleSheets(payload);

    startDownloadFromModal(modal);
    form.reset();
    updateSubmitState(form, modal);
    closeModal();
  }

  function onKeydown(event) {
    if (event.key === 'Escape') {
      const modal = getModal();
      if (modal && modal.classList.contains('is-open')) {
        closeModal();
      }
    }
  }

  document.addEventListener('click', onDocumentClick);
  document.addEventListener('input', onDocumentInput);
  document.addEventListener('change', onDocumentInput);
  document.addEventListener('submit', onDocumentSubmit);
  document.addEventListener('keydown', onKeydown);
})();
